export const objectEqual = (obj, field) => {
  return obj.reduce((acc, data) => {
    Object.keys(field).forEach((Fkey) => {
      if (data[Fkey] !== undefined && data[Fkey] !== "") {
        acc[Fkey] = data[Fkey];
      } else {
        acc[Fkey] = null;
      }
    });
  
    return acc;
  }, {});
};

export const objectEqual2 = (obj, field) => {
  const result = [];
  obj.forEach((data) => {
    const child = {};
    Object.keys(field).forEach((Fkey) => {
      if (data[Fkey] !== undefined && data[Fkey] !== "") {
        child[Fkey] = data[Fkey];
      } else {
        child[Fkey] = null;
      }
    });
    result.push(child);
  });
  return result;
};


export const objectLength = (obj, field) => {
  const result = {};

  const flatten = (obj, field) => {
    Object.keys(field).forEach((key) => {
      if (Array.isArray(obj)) {
        obj.forEach((item) => {
          if (
            item[key] !== undefined &&
            item[key] !== "" &&
            item[key] !== null
          ) {
            result[key] = item[key];
          }
        });
      }
    });
  };

  flatten(obj, field);
  return Object.keys(result);
};
